const config = {
    API_URL: process.env.REACT_APP_API_URL,
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    CALENDLY_USERNAME: process.env.REACT_APP_CALENDLY_USERNAME
};

// Log the current environment and API URL
console.log('Current Environment:', process.env.NODE_ENV);
console.log('API URL:', config.API_URL);

export default config; 